import React, { useState } from 'react';
import { Link, Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from './Toast';
import './Login.css';

function Login() {
  const { user, loading, login } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const fromQuery = searchParams.get('from');
  const from =
    location.state?.from?.pathname ||
    (fromQuery && fromQuery.startsWith('/') ? fromQuery : null) ||
    '/research/reports';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (loading) {
    return <div className="auth-loading-screen">Loading…</div>;
  }

  if (user) {
    return <Navigate to={from} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      showToast(
        err.response?.data?.error || err.message || 'Login failed',
        'error'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img
          src={`${process.env.PUBLIC_URL || ''}/branding/racontera-logo.png`}
          alt="Racontera"
          className="login-logo"
        />
        <h1 className="login-title">Sign in</h1>
        <p className="login-sub">Use your account email and password.</p>
        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-label" htmlFor="login-email">
            Email
          </label>
          <input
            id="login-email"
            type="email"
            className="login-input"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <label className="login-label" htmlFor="login-password">
            Password
          </label>
          <input
            id="login-password"
            type="password"
            className="login-input"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="login-submit" disabled={submitting}>
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <div className="login-footer-links">
          <Link to="/">Back to home</Link>
          <span>|</span>
          <Link to="/#beta">Request beta access</Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
